
// COM Rutas API REST *****************************
const CONSULTAR_INFORMACION_USUARIO = '/autenticacion/consultarInformacionUsuario';
const VERIFICACION_CODIGO_SMS = '/autenticacion/verificacionCodigoSMS';
const VALIDAR_SESSION_ACTIVA = '/autenticacion/validarSessionGuardianComponentes';
const LOGIN_REDIRECCIONADO = '/autenticacion/loginRedireccionado';
const LOGIN = '/autenticacion/login';
const GENERAR_CODIGO_VERIFICACION = '/autenticacion/generarCodigoVerificacion';
const VALIDAR_USUARIO_PARA_RECUPERAR_CONTRASENA = '/autenticacion/validarUsuarioParaRecuperarContrasena';
const ACTUALIZAR_CONTRASENA = '/autenticacion/actualizarContrasena';

const CONSULTAR_EMPRESAS = '/administrativo/consultarEmpresas';
const CONSULTAR_GRUPOS_POR_ID_EMPRESA = '/administrativo/consultarGruposPorIdEmpresa';
const CONSULTAR_LOTERIAS_POR_ID_MODALIDAD = '/administrativo/consultarLoteriaPorIdModalidad';
const CONSULTAR_AGENCIAS_POR_ID_GRUPO = '/administrativo/consultarAgenciasPorIdGrupo';
const CONSULTAR_LOTERIAS = '/administrativo/consultarLoterias';
const CONSULTAR_MODALIDADES = '/administrativo/consultarModalidades';
const CONSULTAR_REPORTE_CORREO = '/administrativo/consultarReporte';
const CONSULTAR_USUARIOS_TEST = '/administrativo/consultarUsuarioTest';
const CONSULTAR_EMPRESAS_POR_ID_SESSION = '/administrativo/consultarEmpresaPorIdSessionUsuario';
const CONSULTAR_LISTADO_VENDEDORES_POR_ID_AGENCIA = '/administrativo/consultarVendedorPorAgencia/';
const CONSULTAR_HORA_ULTIMA_ACTUALIZACION = '/administrativo/consultarUltimaHoraActualizacionDash';
const CONSULTAR_RECAUDADORES_REPORTE = '/administrativo/consultaListaUsuarioPorDosRoles';

const ALMACENAR_PROGRAMACION_CORREO = '/correo/almacenarProgramacionCorreo';
const CONSULTAR_CORREO_PROGRAMADOS = '/correo/consultarCorreosProgramados';
const ELIMINAR_PROGRAMACION_CORREO = '/correo/eliminarCorreoProgramado';

const CONSULTAR_LISTADO_NUMEROS_MAS_JUGADOS = '/monitoreo/consultarMonitoreoNumerosMasJugados';
const CONSULTAR_DETALLE_NUMERO_MAS_JUGADO = '/monitoreo/consultarDetalleNumeroMasJugado';
const CONSULTAR_DETALLE_NUMERO_MAS_JUGADO_TOP_DIEZ = '/monitoreo/consultarTopDiez';
const CONSULTAR_TABLA_DETALLE_SUCURSALES = '/monitoreo/consultarInformacionTablaDetalleSucursales';
const CONSULTAR_TOTALES_CARD_DETALLE_SUCURSALES = '/monitoreo/consultarTotalesCardDetalleSucursales';
const CAMBIAR_ESTADO_DE_VENTA = '/monitoreo/cambiarEstadoVenta';
const CONSULTAR_MENSAJERIA = '/monitoreo/consultarMensajes';
const CONSULTAR_CANTIDAD_MENSAJES_SIN_LEER = '/monitoreo/consultarCantidadMensajesSinLeer';
const REGISTRAR_RESPUESTA_REMITENTE = '/monitoreo/enviarMensajeRemitente';
const ESTADO_MENSAJE_A_LEIDO = '/monitoreo/mensajeLeido';
const MARCAR_MENSAJES_COMO_LEIDOS = '/monitoreo/marcarMensajesComoLeidos';
const ENVIO_MENSAJERIA = '/monitoreo/envioMensajeria';
const MODAL_BALANCE_OTROS_PRODUCTOS = '/monitoreo/consultarInformacionModalBalanceOtrosProductos';
const MODAL_OTROS_PRODUCTOS = '/monitoreo/consultarInformacionModalOtrosProductos';

const REPORTE_LOTERIA_OTROS_PRODUCTOS = '/reporte/reporteVentasLoteriasOtrosProductos';
const CONSULTAR_LISTADO_CARRERAS_POR_FECHAS = '/reporte/consultarCarrerasPorFechas';
const REPORTE_VENTAS_QUINTE = '/reporte/consultarReporteVentasCarreras';
const REPORTE_PREMIOS_QUINTE = '/reporte/consultarGanadoresCarreras';
const REPORTE_ANULADOS_QUINTE = '/reporte/consultarReporteVentasCarrerasAnuladas';
const REPORTE_RIFAS_BOLETAS_VENDIDAS = '/reporte/consultarReporteBoletasVendidas';
const REPORTE_RIFAS_BOLETAS_GANADORAS = '/reporte/consultarReporteBoletasGanadoras';
const REPORTE_RIFAS_BOLETAS_ANULADAS = '/reporte/consultarReporteBoletasAnuladas';
const REGISTRAR_RIFAS = '/rifas/almacenarRifa';
const OBTENER_RIFAS = '/rifas/consultarRifas';
const ELIMINAR_RIFA = '/rifas/eliminarRifa';
const GENERAR_RIFA = '/rifas/validacionesBalotera';
const VALIDAR_ABREVIATURA_REPETIDA_RIFA = '/rifas/validarAbreviaturaDeRifaRepetida';


const CONSULTAR_RIFAS = '/sorteos/consultarRifas';
const CONSULTAR_FILTROS_SORTEOS = '/sorteos/consultarFiltrosPorIdRifa';
const REGISTRAR_SORTEOS = '/sorteos/almacenarSorteo';
const CONSULTAR_HORA_CIERRE_LOTERIA_CREACION_SORTEO = '/sorteos/compararHorasCierre';
const CONSULTAR_SORTEOS = '/sorteos/consultarSorteos';
const ELIMINAR_SORTEO = '/sorteos/eliminarSorteo';

const CONSULTAR_RIFAS_POR_EMPRESA = '/reporte/consultarRifasAgrupadasPorEmpresa';

// COM Mensajes SWEET ALERT *****************************
const URL_LOGO_SWEET_ALERT = 'Administrativo Todo+';
const MENSAJE_CONFIRMACION_ACTUALIZAR_PROGRAMACION_CORREO = '¿Está seguro de actualizar la programación de correo?';
const MENSAJE_CONFIRMACION_REGISTRAR_PROGRAMACION_CORREO = '¿Está seguro de registrar la programación de correo?';
const MENSAJE_SOLICITUD_CIERRE_SESSION = '¿Está seguro de cerrar sesión?';
const MENSAJE_NOTIFICACION_200 = 'Respuesta de acción exitosa.';
const MENSAJE_EDITARNOT = 'Lo sentimos esta función aún no está disponible.';
const MENSAJE_ACTIVAR_ESTADO_VENTA = '¿Está seguro que desea activar el estado de venta?';
const MENSAJE_INACTIVAR_ESTADO_VENTA = '¿Está seguro que desea inactivar el estado de venta?';
const MENSAJE_CONFIRMACION_ENVIAR_RESPUESTA_DESTINATARIO = '¿Está seguro de enviar respuesta de mensaje?';
const MENSAJE_EXITOSO_RESPUESTA_MENSAJE = 'Se envió exitosamente mensaje de respuesta.';
const MENSAJE_CAMBIOS_ESTADO_MENSAJES_A_LEIDOS = 'Se ha cambiado el estado de los mensajes como leídos.';
const CONFIRMACION_PARA_MARCAR_TODOS_MENSAJES_COMO_LEIDOS = '¿Está seguro de cambiar el estado de los mensajes a leídos?';
const MENSAJE_CAMBIO_ESTADO_EXITOSO = 'Cambio de estado exitoso';
const MENSAJE_SOLICITAR_NUEVO_CODIGO = '¿Está seguro de solicitar un nuevo código?';
// eslint-disable-next-line max-len
const MENSAJE_SOLICITUD_CIERRE_SESSION_GUARDIAN = 'Se detectó que tiene una sesión diferente a la actual o está intentando acceder sin estar autenticado.';
const MENSAJE_SOLICITUD_CIERRE_SESION_POR_SEGURIDAD_NOT_FOUND_404 = 'Se detecto que intentas acceder a una URL no valida.';
const REGISTRO_EXITOSO_MENSAJE = 'Se ha registrado exitosamente el mensaje';
const REGISTRO_ERRONEO_MENSAJE = 'No se registró el mensaje';
const VALIDAR_ACCION_CREAR_MENSAJE = '¿Está seguro de registrar un mensaje?';
const VALIDAR_ACCION_LIMPIAR_FORMULARIO = '¿Está seguro de limpiar los campos del formulario?';
const MENSAJE_CONFIRMACION_ELIMAR_PROGRAMACION_CORREO = '¿Está seguro de eliminar la programación de correo?';
const DESCARGA_EXITOSA_BASE64_EXCEL = 'Se ha descargado exitosamente el reporte Excel.';
const DESCARGA_EXITOSA_BASE64_PDF = 'Se ha descargado exitosamente el reporte Pdf.';
const MENSAJE_USUARIO_VERIFICADO_CON_EXITO = 'Usuario verificado con éxito, se le enviará un mensaje de texto con un código';
const CODIGO_VERIFICACION_EXITOSO = 'Se ha verificado exitosamente el código ingresado.';
const MENSAJE_INGRESE_NUEVA_CONTRASENA = 'Por favor diligencie los campos solicitados para restaurar su contraseña.';
const MENSAJE_ACTUALIZACION_EXITOSA_CONTRASENA = 'Actualización exitosa de contraseña.';
const MENSAJE_REGISTRO_SORTEO_EXITOSO = 'El sorteo se ha registrado exitosamente.';
const MENSAJE_CONFIRMACION_ELIMINAR_SORTEO = '¿Está seguro que desea eliminar el registro de sorteo?';
const MENSAJE_EXITOSO_ELIMINAR_SORTEO = 'Se ha eliminado con éxito el sorteo';
const MENSAJE_CONFIRMACION_ELIMINAR_RIFA = '¿Está seguro que desea eliminar el registro de la rifa?';
const MENSAJE_EXITOSO_ELIMINAR_RIFA = 'Se ha eliminado con éxito la rifa';
const MENSAJE_INVALID_ERROR_GENERAR_RIFA = 'Por favor verifique los campos obligatorios.';
const MENSAJE_GENERACION_EXITOSA_RIFA = 'Se genero la rifa exitosamente.';




// COM  Mensajes Error SWEET ALERT **************************
const ERROR_DE_SERVIDOR_503 = 'No se puede comunicar con el servidor. Verifique su conexión a Internet y vuelve a intentarlo.';
const ERROR_CAMPO_NULL = 'Campo obligatorio.';
const ERROR_CAMPO_CANTIDAD_SORTEOS = 'Campo mayor a cero';
const ERROR_RESPUESTA_VACIA_BASE64_EXCEL = 'Ha ocurrido un error en la descarga del reporte Excel.';
const ERROR_RESPUESTA_VACIA_BASE64_PDF = 'Ha ocurrido un error en la descarga del reporte Pdf.';
const FORMULARIO_NO_VALIDO = 'Verifique que los datos seleccionados en el formulario estén completos.';
const EXCEDIO_CANTIDAD_INTENTOS_FALLIDOS_UNO = 'Se ha bloqueado temporalmente el ingreso por intentos fallidos. ';
const EXCEDIO_CANTIDAD_INTENTOS_FALLIDOS_DOS = 'Se enviará un código por mensaje de texto para autenticarse en la app.';
const EXCEDIO_CANTIDAD_CARACTERES_NOMBRE = 'Maximo 50 caracteres';
const EXCEDIO_CANTIDAD_CARACTERES_ABREVIATURA = 'Maximo 5 caracteres';
const ERROR_ABREVIATURA_RIFA_REPETIDA = 'Abreviatura repetida';

const CONTREASENA_NO_COINCIDEN = 'Contraseñas no coinciden';
// eslint-disable-next-line max-len
const ERROR_NO_CONTROLADO = 'Ha ocurrido un error inesperado, se redireccionará nuevamente a la app inicial para validar autenticación.';
const MENSAJE_USUARIO_NO_VALIDO = 'Usuario no válido, por favor verifique.';
const MENSAJE_EXCEDIO_CANTIDAD_PROGRAMACION_SORTEO = 'Has programado el máximo de ';
const MENSAJE_EXCEDIO_CANTIDAD_PROGRAMACION_SORTEO_DOS = 'sorteos, para la rifa ';
const MENSAJE_ERROR_CREANDO_RIFA = 'Ha ocurrido un error al generar la rifa.';



// COM Toast ************************************************
const TOAST_NUEVO_MENSAJE = 'Hemos detectado que tienes ';
const TOAST_CONTRASENA_REQUERIDA = 'Contraseña requerida';
const TOAST_USUARIO_REQUERIDA = 'Usuario requerido';

// COM Redireccion de componentes **************************
const REDIRECCIONARHOME = '/home';
const REDIRECCIONARMONITOREO_NUMEROS_MAS_JUGADOS = 'monitoreo/numeros-mas-jugados';
const REDIRECCIONADMINCORREO = 'reporte/administrador-correo';
const REDIRECCIONAUTENTICACION = '/autenticacion/login';
const REDIRECCIONAUTENTICACION_REDIRECCIONADO = '/autenticacion/login';
const REDIRECCION_CODIGO_VERIFICACION = '/autenticacion/codigoSMS';
const REDIRECCIONAREMPRESA = '/';
const REDIRECCIONARLOTERIAS = '/';
const REDIRECCIONARPRODUCTOS = '/';
const REDIRECCIONARSEGURIDAD = '/';
const REDIRECCIONARADMINISTRACION = '/';
const REDIRECCIONARREPORTES_VENTA_LOTERIA_OTROS_PRODUCTOS_POR_VENDEDOR = 'reporte/venta-loterias-y-otros-productos';
const REDIRECCIONARREPORTES_RIFAS_BOLETAS_VENDIDAS = 'reporte/boletas-vendidas';
const REDIRECCIONARREPORTES_RIFAS_BOLETAS_GANADORAS = 'reporte/boletas-ganadoras';
const REDIRECCIONARREPORTES_RIFAS_BOLETAS_ANULADAS = 'reporte/boletas-anuladas';
const REDIRECCIONARCONSULTARAGENCIAS = '/';
const REDIRECCIONARLANDINGPAGE = 'general/home';
const REDIRECCIONARMONITOREO_DETALLE_SUCURSALES = 'monitoreo/detalle-sucursales';
const REDIRECCIONARMONITOREO_MENSAJERIA = 'monitoreo/mensajeria';
const REDIRECCIONARSORTEOS_REGISTRO = 'rifas/registro-sorteo';
const REDIRECCIONARRIFAS_REGISTRO = 'rifas/registro-rifas';


// COM Expresiones Regulares **************************
// eslint-disable-next-line max-len
const REGEX_VALIDAR_EMAIL = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const REGEX_VALIDAR_CADENA_BASE64 = /^(?:[A-Z0-9+\/]{4})*(?:[A-Z0-9+\/]{2}==|[A-Z0-9+\/]{3}=|[A-Z0-9+\/]{4})$/i;


// COM PARAMS VALID FROM CARIBBEAN PHP **************************
const PARAMS_MONITOREO = 'monitoreo';
const PARAMS_CORREO = 'correo';
const PARAMS_SUCURSALES = 'sucursales';
const PARAMS_REPORTE_VENTA_LOTERIA_OTROS_PRODUCTOS = 'reporte';
const PARAMS_REPORTE_BOLETAS_VENDIDAS = 'boletasVendidas';
const PARAMS_REPORTE_BOLETAS_GANADORAS = 'boletasGanadoras';
const PARAMS_REPORTE_BOLETAS_ANULADAS = 'boletasAnuladas';
const PARAMS_REGISTRO_SORTEO = 'sorteos';
const PARAMS_REGISTRO_RIFAS = 'rifas';


// COM VISTAS **************************
const VISTA_MONITOREO = 'monitoreo';
const VISTA_ADMIN_CORREO = 'correo';
const VISTA_MENSAJERIA = 'mensajeria';
const VISTA_DETALLE_SUCURSALES = 'sucursales';
const VISTA_REPORTE_LOTERIA_OTROS_PRODUCTOS = 'venta-loterias-y-otros-productos';
const VISTA_BOLETAS_VENDIDAS = 'boletasVendidas';
const VISTA_VENTAS_QUINTE = 'VentasQuinte';
const VISTA_REGISTRO_SORTEOS = 'sorteos';
const VISTA_REGISTRO_RIFAS = 'rifas';

// COM Estados **************************
const ESTADO_ACTIVO = 'A';
const ESTADO_INACTIVO = 'I';
const MENOS_UNO = -1;
const UNO = 1;

// COM Tipo reporte ********************
const TIPO_REPORTE_PDF = 0;
const TIPO_REPORTE_EXCEL = 1;

// COM Codigos error **************************
const CODIGO_USUARIO_SESSION_INACTIVA = 'ADM27';

// COM MIME ---> Multipurpose Internet Mail Extensions
const MIME_PDF_1 = 'application/pdf';
const MIME_PDF_2 = 'data:application/pdf;base64';
const MIME_PDF_3 = 'application/pdf;base64';
const MIME_EXCEL = 'data:application/vnd.ms-excel;base64';
const MIME_EXCEL_2 = 'data:application/octet-stream;base64';

// COM Util focus
const CAMPO_CONTRASENA = 'contrasena';
const CAMPO_USUARIO = 'usuario';


// COM Roles *********************************
const ROL_RECAUDADOR = 3;

// COM Scroll visor id
const SCROLL_TO_PDF_VISOR = '#visorPdf';

// COM Agrupador *********************************
const AGRUPADOR_AGENCIA = 3;
const AGRUPADOR_EMPRESA = 1;

// COM Tipo de sorteo
const PRINCIPAL = 1;
const SECUNDARIO = 2;

// COM Tipo de reporte
const TIPOREPORTE_DEFECTO = 1;



export const constantes = {
  CONSULTAR_INFORMACION_USUARIO,
  VERIFICACION_CODIGO_SMS,
  CONSULTAR_EMPRESAS,
  CONSULTAR_AGENCIAS_POR_ID_GRUPO,
  CONSULTAR_GRUPOS_POR_ID_EMPRESA,
  CONSULTAR_LOTERIAS_POR_ID_MODALIDAD,
  CONSULTAR_LOTERIAS,
  CONSULTAR_MODALIDADES,
  CONSULTAR_REPORTE_CORREO,
  CONSULTAR_CORREO_PROGRAMADOS,
  ALMACENAR_PROGRAMACION_CORREO,
  ELIMINAR_PROGRAMACION_CORREO,
  URL_LOGO_SWEET_ALERT,
  ERROR_DE_SERVIDOR_503,
  ERROR_CAMPO_NULL,
  REDIRECCIONARHOME,
  REDIRECCIONARMONITOREO_NUMEROS_MAS_JUGADOS,
  REDIRECCIONAREMPRESA,
  REDIRECCIONARLOTERIAS,
  REDIRECCIONARPRODUCTOS,
  REDIRECCIONARSEGURIDAD,
  REDIRECCIONARADMINISTRACION,
  REDIRECCIONARREPORTES_VENTA_LOTERIA_OTROS_PRODUCTOS_POR_VENDEDOR,
  REDIRECCIONARREPORTES_RIFAS_BOLETAS_VENDIDAS,
  REDIRECCIONARREPORTES_RIFAS_BOLETAS_GANADORAS,
  REDIRECCIONARREPORTES_RIFAS_BOLETAS_ANULADAS,
  REDIRECCIONARCONSULTARAGENCIAS,
  CONSULTAR_LISTADO_NUMEROS_MAS_JUGADOS,
  CONSULTAR_DETALLE_NUMERO_MAS_JUGADO,
  CONSULTAR_DETALLE_NUMERO_MAS_JUGADO_TOP_DIEZ,
  REGEX_VALIDAR_EMAIL,
  MENSAJE_CONFIRMACION_REGISTRAR_PROGRAMACION_CORREO,
  PARAMS_MONITOREO,
  PARAMS_CORREO,
  REDIRECCIONADMINCORREO,
  REDIRECCIONAUTENTICACION,
  CONSULTAR_EMPRESAS_POR_ID_SESSION,
  MENSAJE_SOLICITUD_CIERRE_SESSION,
  REDIRECCIONARLANDINGPAGE,
  MENSAJE_NOTIFICACION_200,
  VISTA_MONITOREO,
  VISTA_ADMIN_CORREO,
  MENSAJE_EDITARNOT,
  CONSULTAR_USUARIOS_TEST,
  REDIRECCIONARMONITOREO_DETALLE_SUCURSALES,
  CONSULTAR_LISTADO_VENDEDORES_POR_ID_AGENCIA,
  CONSULTAR_LISTADO_CARRERAS_POR_FECHAS,
  CONSULTAR_TABLA_DETALLE_SUCURSALES,
  CONSULTAR_TOTALES_CARD_DETALLE_SUCURSALES,
  CAMBIAR_ESTADO_DE_VENTA,
  MENSAJE_ACTIVAR_ESTADO_VENTA,
  MENSAJE_INACTIVAR_ESTADO_VENTA,
  ESTADO_ACTIVO,
  ESTADO_INACTIVO,
  REDIRECCIONARMONITOREO_MENSAJERIA,
  CONSULTAR_MENSAJERIA,
  MENOS_UNO,
  CONSULTAR_CANTIDAD_MENSAJES_SIN_LEER,
  TOAST_NUEVO_MENSAJE,
  REGISTRAR_RESPUESTA_REMITENTE,
  MENSAJE_CONFIRMACION_ENVIAR_RESPUESTA_DESTINATARIO,
  ESTADO_MENSAJE_A_LEIDO,
  MARCAR_MENSAJES_COMO_LEIDOS,
  MENSAJE_EXITOSO_RESPUESTA_MENSAJE,
  MENSAJE_CAMBIOS_ESTADO_MENSAJES_A_LEIDOS,
  CONFIRMACION_PARA_MARCAR_TODOS_MENSAJES_COMO_LEIDOS,
  VISTA_MENSAJERIA,
  MENSAJE_CAMBIO_ESTADO_EXITOSO,
  MENSAJE_SOLICITAR_NUEVO_CODIGO,
  ENVIO_MENSAJERIA,
  VISTA_DETALLE_SUCURSALES,
  VALIDAR_SESSION_ACTIVA,
  MENSAJE_SOLICITUD_CIERRE_SESSION_GUARDIAN,
  REGISTRO_EXITOSO_MENSAJE,
  CODIGO_USUARIO_SESSION_INACTIVA,
  VALIDAR_ACCION_CREAR_MENSAJE,
  REGISTRO_ERRONEO_MENSAJE,
  PARAMS_SUCURSALES,
  VALIDAR_ACCION_LIMPIAR_FORMULARIO,
  CONSULTAR_HORA_ULTIMA_ACTUALIZACION,
  MODAL_BALANCE_OTROS_PRODUCTOS,
  MODAL_OTROS_PRODUCTOS,
  MENSAJE_CONFIRMACION_ELIMAR_PROGRAMACION_CORREO,
  MENSAJE_CONFIRMACION_ACTUALIZAR_PROGRAMACION_CORREO,
  UNO,
  VISTA_REPORTE_LOTERIA_OTROS_PRODUCTOS,
  CONSULTAR_RECAUDADORES_REPORTE,
  REPORTE_LOTERIA_OTROS_PRODUCTOS,
  REPORTE_VENTAS_QUINTE,
  REPORTE_PREMIOS_QUINTE,
  REPORTE_ANULADOS_QUINTE,
  REPORTE_RIFAS_BOLETAS_VENDIDAS,
  REPORTE_RIFAS_BOLETAS_GANADORAS,
  REPORTE_RIFAS_BOLETAS_ANULADAS,
  ERROR_RESPUESTA_VACIA_BASE64_EXCEL,
  DESCARGA_EXITOSA_BASE64_EXCEL,
  TIPO_REPORTE_EXCEL,
  TIPO_REPORTE_PDF,
  FORMULARIO_NO_VALIDO,
  ERROR_RESPUESTA_VACIA_BASE64_PDF,
  DESCARGA_EXITOSA_BASE64_PDF,
  MIME_PDF_1,
  MIME_PDF_2,
  MIME_PDF_3,
  MIME_EXCEL,
  MIME_EXCEL_2,
  ROL_RECAUDADOR,
  REGEX_VALIDAR_CADENA_BASE64,
  SCROLL_TO_PDF_VISOR,
  LOGIN_REDIRECCIONADO,
  LOGIN,
  PARAMS_REPORTE_VENTA_LOTERIA_OTROS_PRODUCTOS,
  PARAMS_REPORTE_BOLETAS_VENDIDAS,
  PARAMS_REPORTE_BOLETAS_GANADORAS,
  PARAMS_REPORTE_BOLETAS_ANULADAS,
  AGRUPADOR_AGENCIA,
  AGRUPADOR_EMPRESA,
  GENERAR_CODIGO_VERIFICACION,
  EXCEDIO_CANTIDAD_INTENTOS_FALLIDOS_UNO,
  EXCEDIO_CANTIDAD_INTENTOS_FALLIDOS_DOS,
  TOAST_CONTRASENA_REQUERIDA,
  TOAST_USUARIO_REQUERIDA,
  CAMPO_CONTRASENA,
  CAMPO_USUARIO,
  REDIRECCION_CODIGO_VERIFICACION,
  VALIDAR_USUARIO_PARA_RECUPERAR_CONTRASENA,
  MENSAJE_USUARIO_VERIFICADO_CON_EXITO,
  MENSAJE_SOLICITUD_CIERRE_SESION_POR_SEGURIDAD_NOT_FOUND_404,
  CODIGO_VERIFICACION_EXITOSO,
  MENSAJE_INGRESE_NUEVA_CONTRASENA,
  CONTREASENA_NO_COINCIDEN,
  ACTUALIZAR_CONTRASENA,
  MENSAJE_ACTUALIZACION_EXITOSA_CONTRASENA,
  REDIRECCIONAUTENTICACION_REDIRECCIONADO,
  MENSAJE_USUARIO_NO_VALIDO,
  ERROR_NO_CONTROLADO,
  CONSULTAR_RIFAS,
  CONSULTAR_FILTROS_SORTEOS,
  CONSULTAR_RIFAS_POR_EMPRESA,
  REGISTRAR_SORTEOS,
  CONSULTAR_HORA_CIERRE_LOTERIA_CREACION_SORTEO,
  PRINCIPAL,
  SECUNDARIO,
  MENSAJE_REGISTRO_SORTEO_EXITOSO,
  MENSAJE_EXCEDIO_CANTIDAD_PROGRAMACION_SORTEO,
  MENSAJE_EXCEDIO_CANTIDAD_PROGRAMACION_SORTEO_DOS,
  TIPOREPORTE_DEFECTO,

  // COM --- rifas ---
  ERROR_CAMPO_CANTIDAD_SORTEOS,
  ERROR_ABREVIATURA_RIFA_REPETIDA,
  REGISTRAR_RIFAS,
  OBTENER_RIFAS,
  EXCEDIO_CANTIDAD_CARACTERES_NOMBRE,
  EXCEDIO_CANTIDAD_CARACTERES_ABREVIATURA,
  CONSULTAR_SORTEOS,
  REDIRECCIONARRIFAS_REGISTRO,
  REDIRECCIONARSORTEOS_REGISTRO,
  PARAMS_REGISTRO_RIFAS,
  PARAMS_REGISTRO_SORTEO,
  ELIMINAR_SORTEO,
  MENSAJE_CONFIRMACION_ELIMINAR_SORTEO,
  MENSAJE_EXITOSO_ELIMINAR_SORTEO,
  MENSAJE_INVALID_ERROR_GENERAR_RIFA,
  MENSAJE_CONFIRMACION_ELIMINAR_RIFA,
  MENSAJE_EXITOSO_ELIMINAR_RIFA,
  VISTA_REGISTRO_RIFAS,
  VISTA_REGISTRO_SORTEOS,
  VISTA_BOLETAS_VENDIDAS,
  VISTA_VENTAS_QUINTE,
  ELIMINAR_RIFA,
  GENERAR_RIFA,
  VALIDAR_ABREVIATURA_REPETIDA_RIFA,
  MENSAJE_GENERACION_EXITOSA_RIFA,
  MENSAJE_ERROR_CREANDO_RIFA
};
